<template>
  <div class="general-meeting-list">
    <el-container style="background: white">
      <el-header style="padding: 0">
        <!-- 顶部tab切换 -->
        <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
          <el-tab-pane
            v-for="(tab, index) in tabList"
            :key="index"
            :label="tab.label"
            :name="tab.name"
          ></el-tab-pane>
        </el-tabs>
        <el-form :model="queryForm" :inline="true" label-width="100px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="会议时间：">
                <el-date-picker
                  v-model="queryForm.meetingDate"
                  type="date"
                  placeholder="-请选择-"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div class="search-btns">
                  <el-button type="primary" icon @click="handleSearch"
                    >查询</el-button
                  >
                  <el-button type="info" icon @click="resetSearch"
                    >重置</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              icon="el-icon-upload2"
              @click="clickTiBao"
            >
              提报
            </el-button>
            
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="createGeneralMeeting"
              v-if="btnAuthorize.addBtn.btnEnable"
              >新增</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-refresh-left"
              @click="callbackGeneralMeeting"
              v-if="btnAuthorize.callback.btnEnable"
              >撤回</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="editGeneralMeeting"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              >修改</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-delete"
              @click="deleteGeneralMeeting"
              v-if="btnAuthorize.delBtn.btnEnable"
              >删除</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-upload2"
              @click="uploadGeneralMeetingMinutes"
              v-if="btnAuthorize.summaryBtn.btnEnable"
              >上传会议纪要</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-upload2"
              @click="uploadGeneralMeetingFeedback"
              v-if="btnAuthorize.feedbackBtn.btnEnable"
              >上传会议反馈</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main>
        <el-table
          :data="tableData"
          ref="meetingTableRef"
          border
          size="mini"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="gotoDetail"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumnDatas"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="status" show-overflow-tooltip label="状态">
            <template slot-scope="scope">
              <div>{{ getStatusLabel(scope.row.status) }}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { tabList, getStatus } from "./variables";
import Constants from "@/utils/consts";
import {
  deleteConference,
  getConferenceList,
  callbackConference,
  conferenceCommitAPi,
} from "@/services/conferenceServices";
export default {
  name: "GeneralMeetingList",
  data() {
    return {
      tabList: tabList,
      activeName: "first",
      queryForm: {
        meetingDate: undefined,
        meetingRoom: undefined,
      },
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [], // 返回的列表数据
      tableColumnDatas: [
        { prop: "workDate", label: "会议日期" },
        { prop: "createTime", label: "提报日期" },
        { prop: "title", label: "会议主题" },
      ],
      selectedItems: [],
      meetingType: 1,
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        callback: { key: "callback", btnEnable: false }, //撤回
        summaryBtn: { key: "summary", btnEnable: false },
        feedbackBtn: { key: "feedback", btnEnable: false },
      },
    };
  },
  methods: {
    /**
     * 点击提报后，将选择的直接掉接口提报了.一次只能提报一个
     */
    clickTiBao() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请选择目标数据", "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert("一次只能选择一条数据", "提示");
        return;
      }

      this.$confirm("您确定要提报选定的会议吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        conferenceCommitAPi({ conferenceId: this.selectedItems[0].id })
          .then((res) => {
            console.log("===res", res);
            if (res.code == Constants.Code_OK) {
              this.getList();
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            this.$alert(error, "提示");
          });
      });
    },
    // 原来后台记录的状态值跟现在的需求不是一一对应
    getStatusLabel(status) {
      if (status == 0 || status == 2) {
        return "草稿";
      }
      if (status == 1) {
        return "已提报";
      }
      return "";
    },
    onActive(menuCode) {
      console.log("menuCode111", menuCode);
      this.activeName = "first";
      this.currentPage = 1;
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getList();
    },
    getList() {
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        // room: this.queryForm.meetingRoom,
        type: this.meetingType,
        workDate: this.queryForm.meetingDate
          ? this.queryForm.meetingDate.toLocaleDateString().replaceAll("/", "-")
          : undefined,
        status: getStatus(this.activeName),
      };
      getConferenceList(params)
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.tableData = res.data || [];
            this.totalCount = res.total || 0;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {});
    },
    handleTabClick() {
      // 切换tab
      this.currentPage = 1;
      this.getList();
    },
    handleSearch() {
      // 按照查询条件查询列表
      console.log("-- search", this.queryForm);
      this.currentPage = 1;
      this.getList();
    },
    resetSearch() {
      this.currentPage = 1;
      this.queryForm.meetingDate = undefined;
      this.queryForm.meetingRoom = undefined;
      this.getList();
    },
    createGeneralMeeting() {
      this.bus.$emit("navMenuChange", {
        routeId: "createGeneralMeeting",
      });
    },
    callbackGeneralMeeting() {
      //撤回会议,每次只能一项
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }

      let { status } = this.selectedItems[0];
      console.log("撤回", status);
      if (status != 1) {
        // 1-提交，只有提交状态才能撤回
        this.$alert("当前会议不能撤回!", "提示");
        return;
      }

      this.$confirm("您确定要撤回选定的会议吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return callbackConference({ conferenceId: this.selectedItems[0].id });
        })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.getList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(() => {});
    },
    editGeneralMeeting() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }

      let { status } = this.selectedItems[0];
      console.log("修改", status, typeof status);
      if (status != 2 && status != 0) {
        this.$alert("当前会议不能修改!", "提示");
        return;
      }

      this.bus.$emit("navMenuChange", {
        routeId: "editGeneralMeeting",
        routeParam: {
          id: this.selectedItems[0].id,
        },
      });
    },
    deleteGeneralMeeting() {
      // 删除会议。每次只能删除一项
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }

      let { status } = this.selectedItems[0];
      if (status != 2) {
        this.$alert("当前会议不能删除!", "提示");
        return;
      }

      this.$confirm("此操作将永久删除已选会议, 是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return deleteConference({ conferenceId: this.selectedItems[0].id });
        })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.getList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {});
    },
    uploadGeneralMeetingMinutes() {
      // 上传会议纪要
      if (this.selectedItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      let target = this.selectedItems[0];
      this.bus.$emit("navMenuChange", {
        routeId: "generalMeetingDetail",
        routeParam: {
          id: target.id,
        },
      });
    },
    uploadGeneralMeetingFeedback() {
      // 上传会议反馈
      if (this.selectedItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      let target = this.selectedItems[0];
      this.bus.$emit("navMenuChange", {
        routeId: "generalMeetingDetail",
        routeParam: {
          id: target.id,
        },
      });
    },
    handleSelectionChange(val) {
      // 选择数据项
      this.selectedItems = val;
    },
    rowClicked(row, event, column) {
      // 点击切换行选中状态
      this.$refs.meetingTableRef.toggleRowSelection(row);
    },
    gotoDetail(row, column, cell, event) {
      // 查看会议详情
      this.bus.$emit("navMenuChange", {
        routeId: "generalMeetingDetail",
        routeParam: {
          id: row.id,
        },
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.general-meeting-list {
  height: 100%;
}

/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
/deep/.el-tabs__item:hover {
  color: #069dbc;
}

.search-btns {
  text-align: right;
}

.el-main {
  min-height: 200px;
  height: auto !important;
}
</style>
